import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  Auth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signInWithPopup,
  OAuthProvider,
  signOut,
  getAdditionalUserInfo,
} from '@angular/fire/auth';
import {
  Firestore,
  doc,
  setDoc,
  getDoc,
} from '@angular/fire/firestore';
import { User } from 'src/app/models';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private auth: Auth,
    private firestore: Firestore,
    private router: Router
  ) {}

  register(email: string, password: string) {
    return createUserWithEmailAndPassword(this.auth, email, password);
  }

  loginEmailPassword(email: string, password: string) {
    return signInWithEmailAndPassword(this.auth, email, password);
  }

  loginMicrosoft() {
    const microsoftAuthProvider = new OAuthProvider('microsoft.com');

    microsoftAuthProvider.setCustomParameters({
      tenant: '6eeb49aa-436d-43e6-becd-bbdf79e5077d',
    });

    microsoftAuthProvider.addScope('User.Read');
    microsoftAuthProvider.addScope('openid');
    microsoftAuthProvider.addScope('profile');

    this.loginProvider(microsoftAuthProvider);
  }

  async loginProvider(provider: OAuthProvider) {
    try {
      const result = await signInWithPopup(this.auth, provider);
      const additionalInfo = getAdditionalUserInfo(result);
      const profile = additionalInfo?.profile as any;

      const userRef = doc(this.firestore, `users/${result.user.uid}`);
      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) {
        const usuario: User = {
          id: result.user.uid,
          mail: profile?.userPrincipalName ?? result.user.email ?? '',
          displayName: profile?.displayName ?? result.user.displayName ?? '',
          givenName: profile?.givenName ?? '',
          surname: profile?.surname ?? '',
          photo_url: result.user.photoURL ?? '',
          role: 'estudiante',
        };
        await this.agregarUsuario(usuario);
      }

      const { redirect } = window.history.state;
      this.router.navigateByUrl(redirect || '/home');

    } catch (err: any) {
      console.error('Login error:', err);
    }
  }

  async logout() {
    localStorage.clear();
    this.router.navigateByUrl('/landing');
    await signOut(this.auth);
  }

  agregarUsuario(usuario: User) {
    const userRef = doc(this.firestore, `users/${usuario.id}`);
    return setDoc(userRef, usuario);
  }
}
